import React, { Component } from "react";
import {
  USERNAME_VALIDATION_ERROR_MESSAGE,
  PASSWORD_VALIDATION_ERROR_MESSAGE
} from "../../utils/constants";
import infoIcon from '../../images/Info-filled.svg';
import TaggingHelper from "../../tagging/tagging-helper";
import ErrorHandler from "../../utils/error-handler";
import { requestOtp } from "../../services/rest";

class LoginDetails extends Component {
  state = {
    usernameActive: false,
    passwordActive: false,
  };

  activateField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: true
    });
  };

  disableField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: false
    });
  };

  sendtOtp = (e, username, password, showUILoader) => {
    e.preventDefault();
    const { goto } = this.props;
    showUILoader(true);

    requestOtp(username, password, this.state.token)
      .then(response => {
        if (response.data && response.data.result) {
          const message = response.data.result.message || '';
          const data = {
            message,
            currentState: { ...this.state, username, password }
          };
          goto('ENTER_OTP', data);
        } else {
          throw new Error('UNEXPECTED_ERROR');
        }
      })
      .catch(error => {
        ErrorHandler.handleLoginOtpRequestError(
          error,
          goto,
          this.state,
          'LOGIN'
        );
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.loginApiErrorEvent(errorMessage);
      })
      .finally(() => {
        showUILoader(false);
      });
  };

  render() {
    const {
      goto,
      isUsernameValid,
      hidden,
      password,
      isPasswordValid,
      handleUsernameChange,
      handlePasswordChange,
      toggleShow,
      username,
      isOldLogin,
      showUILoader
    } = this.props;
    const { usernameActive, passwordActive } = this.state;
    return (
      <React.Fragment>
        <div className="card-header">
          <h2>Log in to your account</h2>
          <p>
            {"Don't have an account yet? "}
            <button
              type="button"
              className="button-link"
              onClick={() => {
                goto("CREATE_PROFILE");
              }}
              automationid="LOGIN_FORM_LOGINDETAILS_1"
            >
              {` Register now `}
            </button>
          </p>
        </div>
        <div className="field-group">
          <label className={usernameActive || username ? "active" : ""}>
            {"Cell number or email/username"}
          </label>
          <div className="loginDetailsFormInputContainer">
            <input
              type="text"
              name="username"
              maxLength="50"
              value={username}
              className={
                !usernameActive && username && !isUsernameValid ? "error" : ""
              }
              onChange={handleUsernameChange}
              onFocus={this.activateField}
              onBlur={this.disableField}
              automationid="LOGIN_FORM_LOGINDETAILS_2"
            />
          </div>
          {!usernameActive && username && !isUsernameValid && (
            <p className="infield-error-label">
              {USERNAME_VALIDATION_ERROR_MESSAGE}
            </p>
          )}
        </div>
        <div className="field-group">
          <label className={passwordActive || password ? "active" : ""}>
            {"Password"}
          </label>

          <div className={"loginDetailsFormInputContainer"}>
            <input
              type={hidden ? "password" : "text"}
              name="password"
              value={password}
              className={
                !passwordActive && password && !isPasswordValid ? "error" : ""
              }
              onChange={handlePasswordChange}
              onFocus={this.activateField}
              onBlur={this.disableField}
              automationid="LOGIN_FORM_LOGINDETAILS_3"
            />

            <div
              className={
                !password
                  ? "invisible-element loginDetailsFormInputHelper"
                  : "loginDetailsFormInputHelper"
              }
              onClick={toggleShow}
            >
              {hidden ? "SHOW" : "HIDE"}
            </div>
          </div>
          {!passwordActive && password && !isPasswordValid && (
            <p className="infield-error-label">
              {PASSWORD_VALIDATION_ERROR_MESSAGE}
            </p>
          )}
        </div>


        {!isOldLogin ?
          <div className="field-helper-text">
            <img src={infoIcon} className="close-icon" alt="close_icon" align="center" />
            <p style={{ margin: "0px 0px 0px 10px" }}>
              To improve security, we have introduced 2-step verification
            </p>
          </div>
          :
          <button
            type="button"
            className="button-link"
            onClick={() => goto("LOGIN_OTP")}
            automationid="LOGIN_FORM_LOGINDETAILS_4"
          >
            Log in with OTP
          </button>
        }


        <div className="action-button-wrapper login-action-button-wrapper">
          <button
            type="submit"
            className="btn btnRed"
            disabled={!isUsernameValid || !isPasswordValid}
            onClick={e => !isOldLogin ? this.sendtOtp(e, username, password, showUILoader) : this.props._onPasswordLogin(e)}
            automationid="LOGIN_FORM_LOGINDETAILS_5"
          >
            NEXT
          </button>
        </div>
        <div className="card-footer">
          <p>
            {"Forgot your "}
            <button
              type="button"
              className="button-link"
              onClick={() => goto("FORGOT_USERNAME")}
              automationid="LOGIN_FORM_LOGINDETAILS_6"
            >
              email or username
            </button>
            ?
          </p>
        </div>
        <div className="card-footer">
          <p>
            {" Forgot your "}
            <button
              type="button"
              className="button-link"
              onClick={() => {
                goto("FORGOT_PASSWORD");
              }}
              automationid="LOGIN_FORM_LOGINDETAILS_7"
            >
              password
            </button>
            ?
          </p>
        </div>
      </React.Fragment >
    );
  }
}

export default LoginDetails;
